<div class="common-wrapper">
    <div class="main-hd-txt">
        <span>
            <h4>CLUSTER<span class="head-btn-style">
                <button *ngIf="!listView" (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab">
                    <i class="bi bi-arrow-left-circle"></i> Back</button></span><span class="head-btn-style">
                    <button *ngIf="!listView" (click)="save($event)" id="btn_cluster_save" class="save-btn-head" [disabled]="saveDisabled" title="Save">
                    <i class="bi bi-file-earmark-plus"></i> Save</button></span></h4>
        </span>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="clusters" [actionExclude]="['feedback','column']" [checkboxCol]="true"
            [entityColumns]="clusterColumns" [selectionField]="'Cluster_Id'" [addEntityIcon]="'bi bi-plus-square'"
            [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'" (downloadEntities)="onExcelExport()"
            (addEntity)="addCluster($event)" (editEntity)="editCluster($event)"
            (refreshEntities)="refreshClusters($event)" (deleteEntity)="deleteCluster($event)"
            (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
            [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)"></grid>

    </div>

    <div *ngIf="!listView">
        <div class="row sub-head">
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearCluster()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div>
        </div>

        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Cluster Name'" [formData]="entity" [maxlength]="100" [mandatory]="true"
                        [fieldName]="'ClusterName'" [(ngModel)]="entity.ClusterName"  id="txt_cluster_name"
                        ngDefaultControl>
                    </textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Code'" [formData]="entity" [maxlength]="10" [mandatory]="true"
                    [fieldName]="'Code'" [(ngModel)]="entity.Code" id="txt_cluster_code"
                    ngDefaultControl></textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Cluster Head'"   [formData]="entity" [data]="employees" [mandatory]="false"
                    [filterable]="true" (filterChanged)="getAllEmployees($event)" [class] = "'form-control'" id="drp_cluster_head"
                    [(ngModel)]="entity.Emp_Ref_Id" [textField]="'EmployeeName'" [valueField]="'Emp_Ref_Id'"
                    [fieldName]="'Emp_Ref_Id'" [selectedItem]="selectedEmployee" ngDefaultControl>
                </dropdown>
                </div>
            </div>

            <div class="row"> 
                <!-- <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Company'" [formData]="entity" [data]="company" [class]="'form-control'"
                        [mandatory]="false" [filterable]="true" (filterChanged)="getAllCompany($event)" id="drp_cluster_company"
                        [(ngModel)]="entity.Company_Id" [textField]="'CompanyName'" [valueField]="'Company_Id'"
                        [fieldName]="'Company_Id'" [selectedItem]="selectedCompany" ngDefaultControl>
                    </dropdown>
                </div> -->
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Area'" [formData]="entity" [data]="division" [class]="'form-control'"
                        [mandatory]="false" [filterable]="true" (filterChanged)="getAllDivision($event)" id="drp_cluster_division"
                        [(ngModel)]="entity.Division_Id" [textField]="'DivisionName'" [valueField]="'Division_Id'"
                        [fieldName]="'Division_Id'" (selectionChanged)="Divisionchanged($event)" [selectedItem]="selectedDivision" ngDefaultControl>
                    </dropdown>
                </div>
                <!-- <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Region'" [formData]="entity" [data]="region" [class]="'form-control'"
                        [mandatory]="false" [filterable]="true"  id="drp_cluster_region"
                        [(ngModel)]="entity.Region_Id" [textField]="'RegionName'" [valueField]="'Region_Id'"
                        [fieldName]="'Region_Id'"  [selectedItem]="selectedRegion" (selectionChanged)="Regionchanged($event)" ngDefaultControl>
                    </dropdown>
                </div>
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'State'" [formData]="entity" [data]="state" [class]="'form-control'"
                        [mandatory]="false" [filterable]="true"   id="drp_cluster_State"
                        [(ngModel)]="entity.State_Id" [textField]="'StateName'" [valueField]="'State_Id'"
                        [fieldName]="'State_Id'" [selectedItem]="selectedState" (selectionChanged)="Statechanged($event)" ngDefaultControl>
                    </dropdown>
                </div>
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Zone'" [formData]="entity" [data]="zone" [class]="'form-control'"
                        [mandatory]="false" [filterable]="true"  id="drp_cluster_Zone"
                        [(ngModel)]="entity.Zone_Id" [textField]="'ZoneName'" [valueField]="'Zone_Id'"
                        [fieldName]="'Zone_Id'" [selectedItem]="selectedZone" ngDefaultControl>
                    </dropdown>
                </div>
              -->                        
             
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Email Id'" [formData]="entity" [maxlength]="100" [mandatory]="false" id="txt_cluster_email"
                        [fieldName]="'EmailId'" [(ngModel)]="entity.EmailId" ngDefaultControl></textbox> 
                </div>  
            
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Phone'" [formData]="entity" [mandatory]="false" [fieldName]="'Phone'" id="txt_cluster_phone"
                        [(ngModel)]="entity.Phone" (keypress)="numberOnly($event)" (paste)="onPaste($event)" [maxlength]="10" ngDefaultControl>
                    </textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <checkbox [caption]="'Active'" [(ngModel)]="entity.IsActive"></checkbox>
                </div>
            </div> 
            <div class="row">
                <!-- <div class="col-md-1">
                    <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'" [type]="'button'"
                        title="Back Tab"></btn>
                </div>
                <div class="col-md-4 mb-2">
                    <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'" [disabled]="saveDisabled" id="btn_cluster_save"
                        [type]="'button'"></btn>
                </div> -->
            </div>
        </div>
       
    </div>
</div>
<ng-template #view let-dataItem let-rowIndex="rowIndex">
    <i class="bi bi-eye-fill" (click)="open(dataItem)"></i>
  </ng-template>
  <kendo-dialog title="Cluster Details" *ngIf="opened" (close)="close()" [height]="500" [width]="1000">
    <div class="col-md-12 content-area">
        <div class="row">
          <div class="col-md-4 br-table-data">
            <label for="ClusterName" class="label label-1">Cluster Name : </label> {{details.ClusterName }}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="Code" class="label label-1">Code : </label> {{details.Code}}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="EmployeeName" class="label label-1">Cluster Head : </label> {{details.EmployeeName}}
          </div>
        </div>
         <!-- </div> -->
          <div class="row">
          <div class="col-md-4 br-table-data">
            <label for="DivisionName" class="label label-1">Area : </label>  {{details.DivisionName}}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="Email" class="label label-1">Email Id : </label>  {{details.EmailId}}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="Phone" class="label label-1">Phone Number : </label>  {{details.Phone}}
          </div>
         </div>
        </div>
    </kendo-dialog>

<kendo-excelexport [data]="clusters.data" [collapsible]="true" fileName="Cluster.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="Sl.No." [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="ClusterName" title="Cluster" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="ClusterCode" title="Code" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="EmployeeName" title="Cluster Head" [width]="200">
    </kendo-excelexport-column>
    <!-- <kendo-excelexport-column field="CompanyName" title="Company" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="ZoneName" title="Zone" [width]="200">
    </kendo-excelexport-column>     
    <kendo-excelexport-column field="StateName" title="State" [width]="200">
    </kendo-excelexport-column>     
    <kendo-excelexport-column field="RegionName" title="Region" [width]="200">
    </kendo-excelexport-column>     -->    
    <kendo-excelexport-column field="ClusterMail" title="Email" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="ClusterPhone" title="Phone" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="DivisionName" title="Area" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column>
</kendo-excelexport>